export default __webpack_public_path__ + "static/media/8.blur.fd379eb8.jpeg";